module.exports = __webpack_public_path__ + "static/media/Inspiration-expand@shortened.f19b587e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/Inspiration-expand@shortened.gif
// module id = 204
// module chunks = 0